import {toggleClass} from "@splidejs/splide/src/js/utils";

window.addEventListener("DOMContentLoaded", () => {
    const checkbox = document.querySelector<HTMLInputElement>(".OverviewComponent .taskDone")

    if (checkbox) {
        const card = checkbox.closest(".card")

        checkbox.addEventListener("change", function () {
            const formData = new FormData();
            formData.append('action', 'taskDone');
            formData.append('security', (window as any).ajax.nonce);
            formData.append('checked', checkbox.checked ? 'true' : 'false');

            fetch((window as any).ajax.url, {
                method: 'POST',
                body: formData,
                headers: {
                    'Accept': 'application/json',
                },
            })

            card.classList.toggle("checked")
        })
    }

    // const button = document.querySelector<HTMLButtonElement>('.WheelOfTasksComponent .button')
    //
    // if (checkbox) {
    //
    //     function getCookie(cname) {
    //         let name = cname + "=";
    //         let decodedCookie = decodeURIComponent(document.cookie);
    //         let ca = decodedCookie.split(';');
    //         for (let i = 0; i < ca.length; i++) {
    //             let c = ca[i];
    //             while (c.charAt(0) == ' ') {
    //                 c = c.substring(1);
    //             }
    //             if (c.indexOf(name) == 0) {
    //                 return c.substring(name.length, c.length);
    //             }
    //         }
    //         return "";
    //     }
    //
    //     let isChecked = checkbox.checked;
    //     if (button) {
    //         const dateString = button.getAttribute("data-next-sunday");
    //         const nextSunday = new Date(dateString);
    //         const nextSundayUTC = nextSunday.toUTCString();
    //
    //         checkbox.addEventListener("change", function () {
    //             if (!isChecked && getCookie("checkbox")) {
    //                 document.cookie = `checkbox=true; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`; //delete cookie
    //             } else {
    //                 document.cookie = `checkbox=true; expires=${nextSundayUTC}; path=/`;
    //             }
    //         });
    //         checkbox.checked = getCookie("checkbox") && !isChecked;
    //     }
    // }
});